import { default as authReducer } from './auth/authSlice';
import { default as loadingReducer } from './loading/loadingSlice';
import { default as userReducer } from './auth/userSlice';
import { default as projectsReducer } from './project/projectsSlice';
import { default as projectReducer} from './project/projectSlice';
import { default as conveyorsReducer } from './conveyor/conveyorsSlice';
import { default as towersReducer } from './tower/towersSlice';
import { default as conveyorReducer} from './conveyor/conveyorSlice';
import { default as projectWriteReducer} from './project/projectWriteSlice';
import { default as conveyorWriteReducer} from './conveyor/conveyorWriteSlice';
import { default as towerWriteReducer} from './tower/towerWriteSlice';
import { default as pulleyReducer} from './conveyor/pulleySlice';
import { default as languageReducer } from './language/languageSlice';

const combinedReducer = {
    auth: authReducer,
    loading: loadingReducer,
    user: userReducer,
    projects: projectsReducer,
    project: projectReducer,
    conveyors: conveyorsReducer,
    towers: towersReducer,
    conveyor: conveyorReducer,
    projectWrite: projectWriteReducer,
    conveyorWrite: conveyorWriteReducer,
    towerWrite: towerWriteReducer,
    pulley: pulleyReducer,
    language: languageReducer,
};

export default combinedReducer;